import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'das-template-string',
  templateUrl: './template-string.component.html',
  styleUrls: ['./template-string.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplateStringComponent {
  @Input() public token: string;
}
